module.exports = __webpack_public_path__ + "images/chosen-sprite-25b9acb1b504c95c6b95c33986b7317e.png";